export default __webpack_public_path__ + "static/media/closet5-before2-1024w.f08b7b2d.avif";